import pager from '@apps-common/js-client/api/pager';
import request from '@apps-common/js-client/api/request';
import {jwtDecode} from 'jwt-decode';

import {
  BASEMAP_RULES_URL,
  MOSAICS_ENDPOINT,
  SERIES_ENDPOINT,
} from '@explorer/config';

export const getMosaicById = async mosaicId => {
  return await request
    .get(`${MOSAICS_ENDPOINT}/${mosaicId}`, {
      params: {
        v: '1.5',
      },
    })
    .then(res => res.data);
};

export const getMosaicByName = async mosaicName => {
  return await request
    .get(`${MOSAICS_ENDPOINT}`, {
      params: {
        v: '1.5',
        name__is: mosaicName,
      },
    })
    .then(res => res.data.mosaics[0]);
};

export const getMosaicsForSeries = async seriesId => {
  return await request
    .get(`${SERIES_ENDPOINT}/${seriesId}/mosaics`, {
      params: {
        v: '1.5',
      },
    })
    .then(res => res.data.mosaics);
};

export const getSeries = onEach => {
  const config = {
    url: SERIES_ENDPOINT,
    params: {
      _page_size: 1000,
    },
    retries: 3,
  };

  return pager(config, 'series', onEach);
};

export const getMosaicRules = async accessToken => {
  // eventually, this rules request may stop needing an api kay
  // see https://hello.planet.com/jira/browse/SEARCH-701
  const apiKey = accessToken ? jwtDecode(accessToken).api_key : '';

  return await request
    .get(`${BASEMAP_RULES_URL}/${apiKey}`, {
      params: {
        v: 1,
        e: 'json',
      },
    })
    .then(response => response.data);
};
